// Import model
import { Message } from '../models/Message';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for Message - handles JSON serialization and deserialization with type validation
 */
export class MessageSerializer {
  /**
   * Deserializes a JSON string into a Message instance
   */
  static deserialize(json: string): Message {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a Message instance
   */
  static fromObject(obj: any): Message {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to Message');
    }


    const instance: Message = {
      role: obj['Role'] as string | undefined,
      text: obj['Text'] as string | undefined,
      contentType: obj['ContentType'] as string | undefined,
      createdOn: obj['CreatedOn'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of Message instances
   */
  static deserializeArray(json: string): Message[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a Message instance to a JSON string
   */
  static serialize(instance: Message): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a Message instance to a plain object
   */
  static toObject(instance: Message): any {
    return {
      'Role': instance.role,
      'Text': instance.text,
      'ContentType': instance.contentType,
      'CreatedOn': instance.createdOn,
    };
  }

  /**
   * Serializes an array of Message instances to a JSON string
   */
  static serializeArray(instances: Message[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
